<template>
  <td v-for="(field, columnName, index) in rowData" :key="columnName">
    <a v-if="field.documentLink" :href="field.documentLink" target="_blank">
      <i class="i-documents-file-pdf" />
    </a>
    <div v-else :data-testid="`sf-column-${index}`">
      {{ field }}
    </div>
  </td>
</template>

<script>
export default {
  name: 'SfTableRow',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
}
</script>
